import { render, staticRenderFns } from "./WriteGallery.vue?vue&type=template&id=380e7d76&scoped=true&"
import script from "./WriteGallery.vue?vue&type=script&lang=js&"
export * from "./WriteGallery.vue?vue&type=script&lang=js&"
import style0 from "./WriteGallery.vue?vue&type=style&index=0&id=380e7d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380e7d76",
  null
  
)

component.options.__file = "WriteGallery.vue"
export default component.exports